module.exports = __webpack_public_path__ + "media/images/version_merge/GooglePlayBtn-72e884043ff525997c2837165e5f8f08.svg";